import type { LandingPageContent } from './types'

export const PV_ANGEBOT_VERGLEICHEN: LandingPageContent = {
  slug: 'pv-angebot-vergleichen',
  lang: 'de',
  topicId: 'pv-angebot-vergleichen',
  title: 'Photovoltaik-Angebote vergleichen – ohne Anruf-Flut',
  metaDescription:
    'Vergleichen Sie mehrere PV-Angebote von Handwerksbetrieben - anonym und unverbindlich, ohne ' +
    'dass Ihre Nummer an alle weitergegeben wird.',
  keywords: [
    'PV Angebote vergleichen',
    'Photovoltaik Angebote vergleichen',
    'Solaranlage Angebote einholen',
    'Solaranlage Angebot vergleichen ohne Anrufe',
    'Photovoltaik Angebotsvergleich',
  ],
  eyebrow: 'So funktioniert der Vergleich',
  h1: 'PV-Angebote vergleichen – ohne Anruf-Flut, ohne Verpflichtung',
  intro:
    'Bei klassischen Vergleichsportalen landet dieselbe Anfrage oft bei mehreren Firmen gleichzeitig ' +
    '- und schon klingelt tagelang das Telefon. Roofora funktioniert anders: Sie bleiben anonym, bis ' +
    'Sie selbst entscheiden, wer Sie kontaktieren darf.',
  sections: [
    { type: 'heading', text: 'So läuft der Angebotsvergleich bei Roofora ab' },
    {
      type: 'list',
      items: [
        'Anfrage stellen: Dachbilder, Zählerschrank-Foto, Ausrichtung und Verbrauch angeben',
        'Anonymisierte Veröffentlichung: Handwerksbetriebe sehen die Anfrage, aber keine Kontaktdaten',
        'Handwerker geben unverbindliche Festpreis-Angebote ab und können sie jederzeit nachbessern',
        'Sie vergleichen die Angebote sortiert nach Preis, ganz in Ruhe',
        'Kontakt entsteht nur, wenn Sie einem einzelnen Betrieb aktiv zustimmen',
      ],
    },
    { type: 'heading', text: 'Warum anonyme Anfragen zu besseren Preisen führen' },
    {
      type: 'paragraph',
      text:
        'Handwerksbetriebe sehen, wie viele Angebote bereits abgegeben wurden - nicht deren Preise. ' +
        'Das erzeugt einen echten Wettbewerb um Ihren Auftrag, ohne dass sich jemand an Ihrer ' +
        'Telefonnummer bedient, bevor Sie überhaupt ein Angebot gesehen haben.',
    },
    { type: 'heading', text: 'Sie entscheiden, wer Sie kontaktieren darf' },
    {
      type: 'paragraph',
      text:
        'Möchte ein Handwerksbetrieb mit Ihnen sprechen, sendet er eine Kontaktanfrage. Sie sehen ' +
        'sein Profil und entscheiden individuell, ob genau dieser Betrieb Ihre Kontaktdaten erhält - ' +
        'keine pauschale Freigabe an alle.',
    },
    { type: 'heading', text: 'Worauf Sie beim Vergleich achten sollten' },
    {
      type: 'list',
      items: [
        'Preis im Kontext des Gesamtpakets, nicht nur die Endsumme',
        'Verwendete Module und Wechselrichter',
        'Garantieumfang auf Material und Montage',
        'Bewertungen aus früheren Projekten',
        'Wie konkret und nachvollziehbar das Angebot aufgeschlüsselt ist',
      ],
    },
    { type: 'heading', text: 'Nicht nur Komplettsysteme: auch Einzelleistungen anfragbar' },
    {
      type: 'paragraph',
      text:
        'Sie brauchen kein komplettes System anzufragen. Wer Module bereits hat oder selbst besorgt, ' +
        'kann gezielt nur die Dachmontage anfragen. Wer die Module schon montiert hat, kann gezielt ' +
        'nur die Elektroinstallation (Wechselrichter, Speicher, Anmeldung beim Netzbetreiber) ' +
        'anfragen - beides läuft über denselben anonymen Angebotsvergleich.',
    },
  ],
  faq: [
    {
      q: 'Wie viele Angebote bekomme ich ungefähr?',
      a: 'Handwerksbetriebe haben 2-4 Wochen Zeit, ein Angebot abzugeben - wie viele es am Ende sind, hängt von Region und Projektgröße ab. Sie sehen jederzeit, wie viele Angebote bereits vorliegen.',
    },
    {
      q: 'Sehen Handwerker die Angebote der Konkurrenz?',
      a: 'Nein. Handwerksbetriebe sehen nur die Anzahl bereits abgegebener Angebote, nicht deren Preise - und können ihr eigenes Angebot jederzeit anpassen.',
    },
    {
      q: 'Muss ich ein Angebot annehmen?',
      a: 'Nein, das Einholen und Vergleichen von Angeboten ist unverbindlich. Sie entscheiden am Ende frei, ob und welches Angebot Sie annehmen.',
    },
  ],
  primaryCta: { label: 'Jetzt kostenlos Angebote vergleichen', action: 'customer' },
  secondaryCta: { label: 'Was kostet eine Solaranlage?', action: 'link', href: '/solaranlage-kosten' },
  relatedLinks: [
    { label: 'Photovoltaik-Anfrage erstellen', href: '/photovoltaik-anfrage-erstellen' },
    { label: 'PV-Installateur finden', href: '/pv-installateur-finden' },
    { label: 'Solaranlage Kosten im Überblick', href: '/solaranlage-kosten' },
    { label: 'Nur Dachmontage benötigt?', href: '/pv-module-montage' },
    { label: 'Nur Elektroinstallation benötigt?', href: '/photovoltaik-elektroinstallation' },
    { label: 'Vergleichen ganz ohne Telefonnummer oder E-Mail', href: '/photovoltaik-ohne-telefonnummer' },
    { label: 'PV-Kostenrechner: Durchschnittspreis in Sekunden', href: '/pv-kostenrechner' },
  ],
}
